const limits = state => state.limits;
const writeOffOptions = state => state.writeOffOptions;

const getMaxAmount = state => state.limits.max_amount;

export default {
  limits,
  writeOffOptions,
  getMaxAmount,
};
